module.exports = __webpack_public_path__ + "img/섀도우댄서 (2).9a6ce21a.png";